import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsTableSvg } from './WpsTableSvg'

export const WpsTableIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={WpsTableSvg} {...props} />
}
